import { getItem } from '@/modules/inventory/services';
import { isValidDateRange } from '@/modules/reservations/utils/dateRange';
import type { CommercialOperationInput } from '@/modules/commercial/types';
import { isItemSelectableForCommercial } from '@/modules/commercial/utils/itemEligibility';

export async function validateCommercialOperationInput(
  input: CommercialOperationInput,
): Promise<string | null> {
  if (!input.title.trim()) return 'El título es obligatorio.';
  if (input.inventoryItemIds.length === 0) {
    return 'Seleccioná al menos un artículo.';
  }

  for (const itemId of input.inventoryItemIds) {
    const item = await getItem(itemId);
    if (!item) return `Artículo no encontrado: ${itemId}.`;
    if (!isItemSelectableForCommercial(item, input.type)) {
      return `El artículo ${item.sku} no es válido para esta operación.`;
    }
  }

  if (input.type === 'rental') {
    if (!input.startDate || !input.endDate) {
      return 'Alquiler requiere fechas de inicio y fin.';
    }
    if (!isValidDateRange(input.startDate, input.endDate)) {
      return 'La fecha de inicio debe ser anterior a la de fin.';
    }
  }

  if (input.subtotal < 0 || input.taxAmount < 0 || input.total < 0) {
    return 'Los importes no pueden ser negativos.';
  }

  return null;
}
